import React from 'react'
import { Icon } from 'antd'

const DollarPoints = ({ typeColor = '#f6a244' }) => (
  <Icon type="dollar" theme="twoTone" twoToneColor={typeColor} />
)

export default DollarPoints
